import { init, captureException as sentryCaptureException } from '@sentry/react';
import packageJson from '../../../package.json';

export const initClientErrorTracking = (self, version = self?.version) => {
  init({
    dsn: 'https://2e2932f3a0e547a9bb90ea34ba66da59@o80863.ingest.sentry.io/1502506',
    attachStacktrace: true,
    release: `rtc@${packageJson.version}`,
    beforeSend (event) {
      if (version) {
        event.tags = event.tags || {};
      }

      if (self) {
        event.tags = event.tags || {};
        event.tags.state = self.rtcState;
        event.extra = {};

        if (self.currentUser) {
          let userId = self.currentUser.username;
          if (userId) {
            const atCharIndex = userId.indexOf('@');
            if (atCharIndex >= 0) {
              userId = userId.slice(atCharIndex);
            }
          }
          event.user = {
            id: userId,
            tenants: self.currentUser.tenants,
            locale: self.currentUser.locale,
          };
          event.extra.capabilities = self.currentUser.capabilities;
          event.extra.audioSettings = self.config.audio;
          event.extra.videoSettings = self.config.video;
          if (self.currentUser.site) {
            event.extra.site = self.currentUser.site;
          }
        }

        if (self.currentCall) {
          event.extra.call = {
            name: self.currentCall.name,
            status: self.currentCall.status,
            isBridged: self.currentCall.isBridged,
            invitationsInProgress: self.currentCall.invitationsInProgress,
          };
          if (self.currentCall.pc) {
            event.extra.peerConnection = {
              iceConnectionState: self.call.pc.iceConnectionState,
              signalingState: self.call.pc.signalingState,
              rtcState: self.rtcState,
            };
          }
        }
      }
      return event;
    },
  });
};

export const captureException = (exception, tags) => {
  if (sentryCaptureException) {
    if (tags) {
      sentryCaptureException(exception, { tags });
    } else {
      sentryCaptureException(exception);
    }
  }
};
